// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos base para VSISE Agentes - Aplicación en español */

/* Reseteo básico */
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

/* Configuración base */
body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/* Transiciones suaves para cambios de tema */
* {
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}

/* Utilidad para ocultar elementos visualmente pero mantenerlos accesibles */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/* Mantener coherencia en safari móvil y otros navegadores */
input,
textarea,
select,
button {
  font-family: inherit;
}

/* Evitar problemas con imágenes */
img {
  max-width: 100%;
  height: auto;
}

/* Estilos para la barra de scroll del textarea en ChatArea */
.custom-scrollbar::-webkit-scrollbar {
  width: 8px; /* Ancho de la barra de scroll */
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent; /* Fondo de la pista */
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #a0aec0; /* Color del pulgar (gris medio) - Modo Claro */
  border-radius: 10px;
  border: 2px solid transparent; /* Espacio alrededor del pulgar para efecto flotante */
  background-clip: content-box;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #718096; /* Color del pulgar al hacer hover (gris más oscuro) - Modo Claro */
}

/* Estilos para modo oscuro */
.dark .custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #4A5568; /* Color del pulgar (gris oscuro) - Modo Oscuro */
}

.dark .custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #2D3748; /* Color del pulgar al hacer hover (gris más oscuro) - Modo Oscuro */
}

/* Estilos para Firefox */
.custom-scrollbar {
  scrollbar-width: thin;
  /* Color del pulgar y de la pista. El segundo valor es la pista. */
  /* Modo Claro: pulgar gris medio, pista transparente */
  scrollbar-color: #a0aec0 transparent;
}

.dark .custom-scrollbar {
  /* Modo Oscuro: pulgar gris oscuro, pista transparente */
  scrollbar-color: #4A5568 transparent;
}

/* Animación para el indicador de "escribiendo..." */
.typing-indicator {
  display: flex;
  align-items: flex-end; /* Alinea los puntos en la base */
}

.typing-indicator span {
  width: 7px;
  height: 7px;
  margin: 0 2px; /* Espacio entre puntos ajustado */
  background-color: #6366f1; /* Color de los puntos - indigo-500 */
  border-radius: 50%;
  opacity: 0.4;
  animation: typing-ellipsis 1.4s infinite ease-in-out both;
}

.dark .typing-indicator span {
  background-color: #818cf8; /* Color de los puntos - indigo-400 para modo oscuro */
}

.typing-indicator span:nth-child(1) {
  animation-delay: -0.32s;
}

.typing-indicator span:nth-child(2) {
  animation-delay: -0.16s;
}

.typing-indicator span:nth-child(3) {
  animation-delay: 0s;
}

@keyframes typing-ellipsis {
  0%, 80%, 100% {
    opacity: 0.4;
    transform: translateY(0);
  }
  40% {
    opacity: 1;
    transform: translateY(-3px); /* Salto de los puntos ajustado */
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAI5D,mBAAmB;AACnB;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE;kFACgF;EAChF,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,+EAA+E;AACjF;;AAEA,6CAA6C;AAC7C;EACE,+EAA+E;AACjF;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,4DAA4D;AAC5D;;;;EAIE,oBAAoB;AACtB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,YAAY;AACd;;AAEA,6DAA6D;AAC7D;EACE,UAAU,EAAE,gCAAgC;AAC9C;;AAEA;EACE,uBAAuB,EAAE,sBAAsB;EAC/C,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,+CAA+C;EAC1E,mBAAmB;EACnB,6BAA6B,EAAE,sDAAsD;EACrF,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB,EAAE,mEAAmE;AAChG;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB,EAAE,iDAAiD;AAC9E;;AAEA;EACE,yBAAyB,EAAE,oEAAoE;AACjG;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,kEAAkE;EAClE,sDAAsD;EACtD,oCAAoC;AACtC;;AAEA;EACE,wDAAwD;EACxD,oCAAoC;AACtC;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,qBAAqB,EAAE,iCAAiC;AAC1D;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa,EAAE,kCAAkC;EACjD,yBAAyB,EAAE,qCAAqC;EAChE,kBAAkB;EAClB,YAAY;EACZ,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB,EAAE,sDAAsD;AACnF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B,EAAE,iCAAiC;EAChE;AACF","sourcesContent":["/* Estilos base para VSISE Agentes - Aplicación en español */\n\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n/* Reseteo básico */\nhtml, body {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n}\n\n/* Configuración base */\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n/* Transiciones suaves para cambios de tema */\n* {\n  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;\n}\n\n/* Utilidad para ocultar elementos visualmente pero mantenerlos accesibles */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n/* Mantener coherencia en safari móvil y otros navegadores */\ninput,\ntextarea,\nselect,\nbutton {\n  font-family: inherit;\n}\n\n/* Evitar problemas con imágenes */\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Estilos para la barra de scroll del textarea en ChatArea */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 8px; /* Ancho de la barra de scroll */\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: transparent; /* Fondo de la pista */\n  border-radius: 10px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background-color: #a0aec0; /* Color del pulgar (gris medio) - Modo Claro */\n  border-radius: 10px;\n  border: 2px solid transparent; /* Espacio alrededor del pulgar para efecto flotante */\n  background-clip: content-box;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background-color: #718096; /* Color del pulgar al hacer hover (gris más oscuro) - Modo Claro */\n}\n\n/* Estilos para modo oscuro */\n.dark .custom-scrollbar::-webkit-scrollbar-thumb {\n  background-color: #4A5568; /* Color del pulgar (gris oscuro) - Modo Oscuro */\n}\n\n.dark .custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background-color: #2D3748; /* Color del pulgar al hacer hover (gris más oscuro) - Modo Oscuro */\n}\n\n/* Estilos para Firefox */\n.custom-scrollbar {\n  scrollbar-width: thin;\n  /* Color del pulgar y de la pista. El segundo valor es la pista. */\n  /* Modo Claro: pulgar gris medio, pista transparente */\n  scrollbar-color: #a0aec0 transparent;\n}\n\n.dark .custom-scrollbar {\n  /* Modo Oscuro: pulgar gris oscuro, pista transparente */\n  scrollbar-color: #4A5568 transparent;\n}\n\n/* Animación para el indicador de \"escribiendo...\" */\n.typing-indicator {\n  display: flex;\n  align-items: flex-end; /* Alinea los puntos en la base */\n}\n\n.typing-indicator span {\n  width: 7px;\n  height: 7px;\n  margin: 0 2px; /* Espacio entre puntos ajustado */\n  background-color: #6366f1; /* Color de los puntos - indigo-500 */\n  border-radius: 50%;\n  opacity: 0.4;\n  animation: typing-ellipsis 1.4s infinite ease-in-out both;\n}\n\n.dark .typing-indicator span {\n  background-color: #818cf8; /* Color de los puntos - indigo-400 para modo oscuro */\n}\n\n.typing-indicator span:nth-child(1) {\n  animation-delay: -0.32s;\n}\n\n.typing-indicator span:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n.typing-indicator span:nth-child(3) {\n  animation-delay: 0s;\n}\n\n@keyframes typing-ellipsis {\n  0%, 80%, 100% {\n    opacity: 0.4;\n    transform: translateY(0);\n  }\n  40% {\n    opacity: 1;\n    transform: translateY(-3px); /* Salto de los puntos ajustado */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
